module.exports = __webpack_public_path__ + "b012de9b5aa79f799a93987385d10343.svg";